// Styles for ConsentList go here.
import styled from 'styled-components';

export const StyledConsentsList = styled.div`
  margin: 2rem;
`;
